import { createContext } from 'react';

export interface LegacyDashboardContextProps {
  endTestingAndActivate: (devices: Array<DeviceId>, page?: string) => void;
  onBulkChangePlan: (devices: Array<DeviceId>, page?: string) => void;
  onDeactivate: (devices: Array<DeviceId>) => void;
  rename: (devices: Array<DeviceId>) => void;
  setDataUsageLimits: (devices: Array<DeviceId>) => void;
  transferToOrganization: (devices: Array<DeviceId>) => void;
  billingPageUrl: string;
}

const LegacyDashboardContext = createContext<LegacyDashboardContextProps | undefined>(undefined);

export default LegacyDashboardContext;
